//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cancelWorkOrder } from '@/api/workOrder';

export default {
    name: 'page-cancel-view',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        workOrderId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            rules: { dealWithRemark: [{ required: true, message: '请输入撤单原因', trigger: 'blur' }] },
            cancelOrderInputDto: {}
        };
    },
    methods: {
        onSaveCancelOrder() {
            const vm = this;
            vm.cancelOrderInputDto.workOrderId = vm.workOrderId;
            this.$refs.cancelOrderForm.validate(async (val) => {
                if (val) {
                    vm.saving = true;
                    cancelWorkOrder(vm.cancelOrderInputDto).then(() => {
                        vm.$emit('input', false);
                        vm.$emit('cancelSuccess');
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        visibleChange(value) {
            if (!value) {
                this.$emit('input', value);
            }
        },
        cancel() {
            this.$refs.cancelOrderForm.resetFields();
            this.$emit('input', false);
        }
    },
    created() {
    },
    watch: {
        workOrderId(val, oldValue) {

        }
    }
};
